var _defs, _ellipse, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreOpSurgeon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 475.24 555.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eaeaea;}.cls-2{fill:#b0c1d6;}.cls-3{fill:#353c4c;}.cls-4{fill:#191a1e;}.cls-5{fill:#292a2d;}.cls-6{fill:#404142;}.cls-7{fill:#040607;}.cls-8{fill:#dfecfc;}.cls-9{fill:#30c178;}.cls-10{fill:#dee8f9;}.cls-11{fill:#fda899;}.cls-12{fill:#fff;}.cls-13{fill:#c5d6ef;}.cls-14{fill:#06b25b;}.cls-15{fill:#00a157;}.cls-16{fill:#f3898b;}.cls-17{fill:#e8887c;}.cls-18{fill:#34354b;}.cls-19{fill:#09183d;}.cls-20{fill:url(#radial-gradient);}.cls-21{fill:#33354a;}.cls-22{fill:url(#radial-gradient-2);}.cls-23{fill:#d64442;}.cls-24,.cls-29{fill:#e8f2fc;}.cls-25{fill:#49140d;}.cls-26{fill:#adadad;}.cls-27{fill:#2e383a;opacity:0.4;}.cls-27,.cls-29{isolation:isolate;}.cls-28{fill:#212435;}.cls-29{opacity:0.33;}.cls-30{fill:#e9f3fe;}.cls-31{fill:#c5c2c5;}.cls-32{fill:#474444;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -309.06,
    cy: 617.59,
    r: 0.5,
    gradientTransform: "matrix(24.01, 0, 0, -27.57, 7642.34, 17154.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9836f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fda899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -312.57,
    cy: 617.91,
    r: 0.48,
    gradientTransform: "translate(-8490.48 17705.5) rotate(180) scale(24.02 28.44)",
    xlinkHref: "#radial-gradient"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    className: "cls-1",
    cx: 237.62,
    cy: 528.67,
    rx: 237.62,
    ry: 27.31
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_550",
    "data-name": "Group 550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    className: "cls-2",
    d: "M211.2,385.32c-14.1.65-26.94.61-38,.21.49-14.54,1.78-52.61,3.52-101.82.78-22,.54-46.93-.11-70.07v-.26l18.78-.84c.09,13.55.29,27.94.68,42.45C197.41,306.8,207.59,365.83,211.2,385.32Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    className: "cls-3",
    d: "M155.57,465.78c0,.54,5.6,38.68,5.6,38.68h19.71l-4.53-29.64Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    className: "cls-3",
    x: 274.07,
    y: 465.28,
    width: 20.62,
    height: 38.71
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    className: "cls-4",
    d: "M226.62,273.43c-.54,2-2.17,77.7,3.81,105.4a420.72,420.72,0,0,1,9.23,98.65H214.14s-5.43-51.35-15.75-87.16-12.49-87.84-12.49-87.84h-7.06s-3.26,58.78-4.34,99.32,4.88,79.05,4.88,79.05h-25s-15.74-96.62-13-123.65-.31-83.78-.31-83.78Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    className: "cls-4",
    d: "M184.62,522.66h-19c-3.12-.21-2.49-2.92-2.49-2.92-3.34-1.67-8.14,2.92-8.14,2.92H128.1c-4.59-.41-5.21-2.5-5.21-2.5v-6.68c.41-14.18,8.13-5.84,18.15-11.68a36.89,36.89,0,0,0,14-14s6.88.42,9.8,5.84,3.34,5.21,8.76,4.59,5.43-5.22,8.14-1,3.13,16,3.13,16a3.82,3.82,0,0,1,2.08,2.51v4a2.45,2.45,0,0,1-1.91,2.88A2.58,2.58,0,0,1,184.62,522.66Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    className: "cls-5",
    d: "M184.62,522.66h-19c-3.12-.2-2.49-2.92-2.49-2.92-3.34-1.67-8.14,2.92-8.14,2.92H128.1c-4.59-.41-5.21-2.5-5.21-2.5v-3.7c7.75.2,17.44.45,20.65.57,5.63.21,12.72-2.92,17.73-3.75s23.57,0,23.57,0a3.81,3.81,0,0,1,2.08,2.5v4a2.44,2.44,0,0,1-1.92,2.88A2.33,2.33,0,0,1,184.62,522.66Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    className: "cls-4",
    d: "M243.55,503.89s-1.06-8.25-6.13-7-2.33-4.44-7.41-5.08-9.09-.42-9.72,3-2.33,2.33-5.08,1.48-3.8.43-4.44,4-2.11,17.13-2.11,17.13H245Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    className: "cls-5",
    d: "M210.5,516.15h33.09a3.26,3.26,0,0,1,3.26,3.25h0a3.26,3.26,0,0,1-3.26,3.26H210.5a3.26,3.26,0,0,1-3.26-3.26h0A3.26,3.26,0,0,1,210.5,516.15Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    className: "cls-5",
    d: "M242.67,513.64a.32.32,0,0,1,0,.17,1.32,1.32,0,0,1-.09.48,2,2,0,0,1-.8.87,4,4,0,0,1-2.13.55H214.14a3.11,3.11,0,0,1-2.93-1.42,1.33,1.33,0,0,1-.1-.48.47.47,0,0,1,0-.17,0,0,0,0,1,0,0c0-.15,0-.3,0-.45a7.54,7.54,0,0,1,2.47-5.33c2.81-2.76,7.72-4.59,13.32-4.59,6.11,0,11.42,2.18,14,5.38a7.1,7.1,0,0,1,1.75,4.54c0,.15,0,.3,0,.45A0,0,0,0,1,242.67,513.64Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    className: "cls-6",
    d: "M240.94,508.63c-3.05,2.1-7.81,3.46-13.16,3.46-6,0-11.25-1.7-14.19-4.25,2.8-2.76,7.71-4.59,13.31-4.59C233,503.25,238.33,505.44,240.94,508.63Z",
    transform: "translate(57.12 -0.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    className: "cls-7",
    d: "M226.19,279.28c-.15,5-.29,12.73-.31,21.89a255.43,255.43,0,0,1-40,3.13c-.07-1.18-.09-1.82-.09-1.82h-7.06l0,.35v1.36a217.74,217.74,0,0,1-36.71-4c-.43-15.18-1-26.74-1-26.74h79.12A49.93,49.93,0,0,1,226.19,279.28Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    className: "cls-8",
    d: "M240.91,290.61h0L232,210.9l1.56,9.69.28,1.76Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    className: "cls-9",
    d: "M240.78,290.59c-.24.06-6.29,1.41-20,3.26a116.58,116.58,0,0,1-22.26,2.72c-3.72.14-7.5.15-11.28.07-11.73.25-23.54-.42-33.54-2.79-14-1.89-23.79-4-23.79-4l10.31-64,.56-3.45L147.3,182h0l-.48-3.58-2.76-20.92-1.16-8.78c5.4-6.53,11-8.68,11.16-8.75h0l11-4.14L177.71,131l.45-19-.2-.28,0-1.67,9.27.83,9.28-.83,0,1.67.25,0-.31,19.19,13,4.9,11,4.14s5.66,2.1,11.17,8.75l-.67,5-3.25,24.68-.48,3.58,4.65,28.89h0Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    className: "cls-10",
    d: "M177,273.81V274q-.08,3.31-.18,6.54c0,1.05-.06,2.09-.1,3.13l0,.6v.1q-.21,6.24-.43,12.23c-1.51,42.91-2.62,75.66-3.06,88.9-26.53-.94-43.11-3.85-43.11-3.85s-.69-38.71-.58-71.81c0-12.95.2-25,.58-33.61.32-7.14.78-14.28,1.32-21,1.73-22.09,4.15-40,4.15-40l41-1.85c0,.09,0,.18,0,.26C177.12,233.37,177.38,254.39,177,273.81Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    className: "cls-10",
    d: "M251.07,381.69c-14,1.91-27.45,3-39.87,3.62-2.66-14.35-8.88-50.12-12.53-88.67v-.06q-.57-6.06-1.06-12.17v-.11c-.08-1-.15-1.94-.22-2.91-.16-2.12-.31-4.24-.43-6.36,0-.33-.05-.66-.07-1-.4-6.4-.69-12.78-.86-19.06-.39-14.51-.59-28.89-.68-42.45L232,210.89h0l8.89,79.72Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    className: "cls-10",
    d: "M237.37,192.46c-1.75,7.71-3.32,13.74-5.36,18.43-3.83,8.82-9.3,12.89-20.68,14.46A138.15,138.15,0,0,1,195.48,227a66,66,0,0,1-18.64-2.59c-3.78-1-8.1-2.3-13.23-4l-1-.33.25-3.42c2-.34,3.93-.63,5.64-.93l1-.19c.72-.13,1.41-.26,2.07-.41l.87-.19a25.18,25.18,0,0,0,4.07-1.25h0l.33-.14a12.21,12.21,0,0,0,2.48-1.43l.26-.21a8.29,8.29,0,0,0,.75-.69l.23-.25.22-.26A8.84,8.84,0,0,0,182,208.9c.06-.1.1-.22.16-.33s.1-.23.15-.35.1-.23.14-.35a12.58,12.58,0,0,0,.48-1.55c0-.14.07-.28.11-.43.09-.42.17-.87.25-1.35,5.26,2.64,8.12,1.58,11.07.11l1-.48q0-6.39,0-12.45c0-28.81.5-51.15.68-58.27l8.7-.48s2.72,1,6.46,2.56c7.31,3.07,18.49,8.3,20.47,12.43C234.59,154.2,242.4,170.26,237.37,192.46Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    className: "cls-10",
    d: "M183.92,192.05l-.16,3.12h0l-.49,9.37c-.08.47-.16.92-.25,1.35,0,.14-.07.28-.11.42a12.58,12.58,0,0,1-.48,1.55,3.65,3.65,0,0,1-.14.35l-.15.35a3.36,3.36,0,0,1-.16.33,8.84,8.84,0,0,1-1.14,1.76l-.22.26-.23.25a7.05,7.05,0,0,1-.75.69l-.26.21a12.21,12.21,0,0,1-2.48,1.43l-.33.15h0a26.22,26.22,0,0,1-4.07,1.25l-.87.19c-.66.14-1.35.28-2.07.41l-1,.19c-1.71.3-3.59.59-5.63.93l-3.05.5c-6.5,1.11-12.68,1.53-18.16.67-7.06-1.11-13-4.35-16.84-11a16.35,16.35,0,0,1-1.78-8.21c-.05-15.13,11.24-40.05,19-49.64,4.54-5.59,12.66-10.24,19.47-13.22.84-.36,1.65-.7,2.45-1a43.35,43.35,0,0,1,7.63-2.41c1.43-.24,2-.05,1.13.65l-1.5,10.66,2.83,10.77c.57,10.23,1.24,23.46,1.81,38.2l3.64-.25C182.24,192.15,183.92,192.05,183.92,192.05Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    className: "cls-11",
    d: "M209.31,191a33,33,0,0,1-4.92,8,10.44,10.44,0,0,1-4.94,3.45,21.35,21.35,0,0,0-4.15,1.68l-1,.48c-3,1.47-5.81,2.53-11.07-.1l.21-4.12.28-5.25s2.57-1.9,9.68-3.16l.91-.15.94-.14A80.18,80.18,0,0,1,209.31,191Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    className: "cls-12",
    d: "M183.92,192l-.16,3.12h0c-.11,0-1.91.24-4.65.55l-3.11.34c-3.11.33-6.83.7-10.58,1-.64.06-1.27.11-1.91.15a117.34,117.34,0,0,1-13.39.48c-9.07-.48-10.9-3-11-3.2.19.05,3.76,1,16.59-.24l5.57-.5,1.7-.15c4.7-.39,9.25-.73,12.91-1l3.63-.25Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    className: "cls-13",
    d: "M146.89,182.46s1.79-17.73,2.27-21.57,2.22,7.57,2.62,13.12-.8,15.29-.8,15.29Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    className: "cls-11",
    d: "M157.78,194.05a77.63,77.63,0,0,0-7.57-10c-3.73-3.92-6.09-6.19-7.41-6s-1.58,1-.94,2.09,5.41,6.16,5.51,6.79-1,.29-1.56-.5-5.14-6.14-6.9-6.72-3.71-.4-3.35.66,2.25,3.22,4,4.9,2.92,3.61,2.77,3.95-1.32.13-1.77-.58-2.72-4.77-3.54-4.88A1.49,1.49,0,0,0,135.8,186c.83,1.36,3,5.06,3.45,5.5s-.51.46-1-.26-1.16-2.89-1.51-2.7a2.84,2.84,0,0,0-.28,2.68c.43,1,.69,2.66,2.59,3.24a47.63,47.63,0,0,0,5.85.39C147.52,194.81,157.78,194.05,157.78,194.05Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    className: "cls-13",
    d: "M209.31,191s8.05-24.3,8.32-32a72.86,72.86,0,0,1-1.86,17c-2.18,9.83-6.13,19.3-8.08,22.23s-8.24,4.26-8.24,4.26S208.28,197.56,209.31,191Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    className: "cls-9",
    d: "M211.13,135.52c-1.94-.81-3.61-1.46-4.76-1.91a33.86,33.86,0,0,0-3.89-5.54H171.93L169,133c-1.43.42-3.14,1-5,1.76,3.19,14.84,9.36,43.76,11.91,57.88-.58-14.74,2.55-28.65,2-38.88l-6.62-10.1,1-6.82,21.26,1.26c-.21,9.22,1.87,28,1.85,53.65C195.29,191.71,205,156.35,211.13,135.52Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    className: "cls-13",
    d: "M233.57,220.59c-3.81,8.15-9.29,12-20.25,13.49-6.93.95-12,1.65-17.29,1.61-5.93,0-12-1-21.1-3.67-2.8-.81-5.88-1.78-9.32-2.93l-1-.34.25-3.41-3,.5c-7.84,1.34-21.27.94-27.51-.77l.56-4.71.54-4.28c5.48.86,17.91,2.14,24.41,1l3.05-.51-.25,3.42,1,.34c4.67,1.55,8.66,2.78,12.2,3.73,8.43,2.29,14.21,3,20.13,2.85a141.78,141.78,0,0,0,15.39-1.59c11.38-1.57,16.85-5.64,20.68-14.46Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    className: "cls-14",
    d: "M204.67,133s7.28,13.89-2.47,27.78l-15-17.56Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    className: "cls-14",
    d: "M169.34,134.53s-7.49,11.58,2.26,25.47l15.17-15.25Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    className: "cls-14",
    d: "M183.76,195.17l.16-3.12s-1.69.1-4.42.29l4.75-40.88c.16-1.4.46-3,1.71-3.68a3,3,0,0,1,3.7,1.33,8.75,8.75,0,0,1,1,4.16q1.4,19.36,2.78,38.74C186.33,193.27,183.76,195.17,183.76,195.17Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    className: "cls-14",
    d: "M196,235.69a28.53,28.53,0,0,1-.42,2.9c-.12.58-.26,1.14-.42,1.71a31.63,31.63,0,0,1-3.94,8.2c-1.28,2-2.91,5.18-5.13,6.25-3,1.42-5.3-3.89-6.58-5.85A23.19,23.19,0,0,1,174.93,232C184,234.66,190.09,235.65,196,235.69Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    className: "cls-15",
    d: "M196,235.69c-5.94,0-12-1-21.1-3.67.09-1.16.23-2.32.36-3.47l.51-4.45c8.44,2.28,14.22,3,20.14,2.84A55.56,55.56,0,0,1,196,235.69Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    className: "cls-14",
    d: "M180,151.52h0a10.35,10.35,0,0,0,7.17,9.23c5.45-1.16,7-6,7.4-8.9a13.45,13.45,0,0,0,.16-2.19l-7.56-5.91L180,149.36A14.16,14.16,0,0,0,180,151.52Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    className: "cls-15",
    d: "M205.52,141.52a64.27,64.27,0,0,1-2.42,14.64L193,148.27l-5.77-4.51-6,4.7-9.87,7.7a62.32,62.32,0,0,1-2.45-15.76,30.19,30.19,0,0,1,.5-5.77,2.84,2.84,0,0,1,.09-.42c1.87-8.92,7.7-10.37,8.39-10.51l.07,0,.05.07,4.79,6.35.06,0a4.85,4.85,0,0,0,.29.49l.37.5a4.91,4.91,0,0,0,6.92.54,4.59,4.59,0,0,0,.54-.54l5.57-7.39h0l.3.07c1.28.34,5.89,2.07,7.84,9.22.09.34.18.7.27,1.07A30.73,30.73,0,0,1,205.52,141.52Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    className: "cls-8",
    d: "M195.48,227a65.66,65.66,0,0,1-18.64-2.59q-.12-5.42-.27-10.73l.33-.15a11.11,11.11,0,0,0,2.48-1.43l.26-.21a6.14,6.14,0,0,0,.75-.69l.23-.24.22-.26a9.21,9.21,0,0,0,1.14-1.77c.06-.1.1-.21.16-.33a3.23,3.23,0,0,0,.15-.34c.05-.12.1-.24.14-.36a13.94,13.94,0,0,0,.49-1.55c0-.14.06-.28.1-.42.09-.43.18-.88.25-1.35,5.26,2.63,8.11,1.57,11.08.1l1-.48q0,4.13,0,8.38C195.38,217.25,195.42,222.07,195.48,227Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    className: "cls-16",
    d: "M196.83,128.68l-.3-.1h0l-5.57,10.05a4.14,4.14,0,0,1-5.53,1.91,4.09,4.09,0,0,1-1.92-1.91l-.38-.69c-.1-.21-.19-.43-.28-.66l-.07,0L178,128.66l-.06-.09-.07,0V112.33L196.67,110l.05,5.68Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    className: "cls-17",
    d: "M220.19,93.82s2.63,2.67,8.95-2S240.48,80.93,235.78,72s-24.62,8.63-24.62,8.63Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    className: "cls-17",
    d: "M152.92,95.3s-2.62,2.68-8.94-2-11.34-10.86-6.64-19.77S162,82.14,162,82.14Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    className: "cls-11",
    d: "M150.78,82.1s.81,19.61,9.24,25.28,16.85,11,29,10.36,25.92-4.48,30-17.79a140,140,0,0,0,5-27.08s5.35-17.82,3.08-30.46-12.8-21.06-31-22-35-.65-43.09,8.91S150.78,82.1,150.78,82.1Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    className: "cls-16",
    d: "M221.26,57.16s-8.82,1.27-17.67-21.7l3.09-3.81Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    className: "cls-16",
    d: "M205.87,35a22.81,22.81,0,0,1-21.44,9.72s-11.2,10.78-26.36,8.26L182,39l24-5.62Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    className: "cls-18",
    d: "M237.62,34.15c-.16,3.56.16,22.68-1.94,25.92,0,0-6.65,6.8-8.43,12s-2.91,9.47-5.34,10.08c0,0-.81-1.49-.33-5.55s1.3-9.72,1.3-9.72a35.27,35.27,0,0,1-1.62-9.72,31.35,31.35,0,0,1-9.4-15.83l.49-2.64L205.87,35l-2.27.49h0c-.24.33-4.4,5.53-20.56,6.47a22.71,22.71,0,0,1-5.17,5.67c-4,3.2-10.48,6.38-19.78,5.34a48.93,48.93,0,0,1-5.83,13.77s.49,13.61-1.46,15.39c0,0-2.43.81-4.37-4.85s-6-10.7-8.43-16.86-9.4-14.74-5.67-27.38a30.61,30.61,0,0,1,7.29-13.6s-1-16.53,18.8-18.64,41,8.91,41,8.91,4.38-6,10.69-4.85,18.15,9.88,21.39,13S237.78,30.58,237.62,34.15Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    className: "cls-19",
    d: "M202.12,22.7S196.89,33.61,188.2,34s-10.74-4.32-10.74-4.32,6.94,3.46,12.33,1.51S202.12,22.7,202.12,22.7Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    className: "cls-19",
    d: "M219.69,33.39l-1,3.78S223,56.72,233,52.73C233,52.72,223.9,54.24,219.69,33.39Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    className: "cls-19",
    d: "M228.6,40.41l-.95,2.92s2.41,8.1,5.32,9.4C233,52.73,228.33,43.92,228.6,40.41Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    className: "cls-19",
    d: "M183,41.92s-7.45,13-24.94,11c0,0-4.38-.81-6.65-4,0,0,9.07,5.35,18.47.65a16.13,16.13,0,0,0,8.11-8.2,13.93,13.93,0,0,0,.6-1.79c.77,0,1.58,0,2.43-.1Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    className: "cls-19",
    d: "M204.78,29.29s2.06,3.4,1.09,5.67l-2.28.5c-.25.32-4.4,5.52-20.57,6.46a38.24,38.24,0,0,1-5-.58,37.36,37.36,0,0,1-7.18-2h0l.65,0c1.19.09,3.79.24,7.08.16.77,0,1.58,0,2.42-.1,1.28-.07,2.62-.18,4-.34,1-.11,1.93-.25,2.91-.41C194.77,37.53,201.74,34.91,204.78,29.29Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    className: "cls-19",
    d: "M204.78,29.29c-1.1,1.78,7.36,26.64,16.48,27.86,8.7,1.17,8.26-2.81,8.26-2.81s-11.88,7.36-17.17-15.66Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    className: "cls-20",
    cx: 227.04,
    cy: 94.06,
    rx: 13.1,
    ry: 12.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    className: "cls-21",
    cx: 229.28,
    cy: 81.36,
    rx: 3.36,
    ry: 4.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    className: "cls-16",
    d: "M186.3,72.66a.24.24,0,0,0,0,.08,1.34,1.34,0,0,0,.28.9c1.23,2.08,2.79,4.24,2.4,6.5-.36,2-2.27,3.77-3,5.77a5.33,5.33,0,0,0,.08,3.87c.2.51,1.78,3.35,2.68,1.67a1.12,1.12,0,0,0-.22-1.16c-.26-.35-.61-.66-.84-1a2.7,2.7,0,0,1,.19-2.83c.51-.89,1.29-1.69,1.85-2.57a7.49,7.49,0,0,0,.94-5.73,13.91,13.91,0,0,0-2.78-5.45,1.14,1.14,0,0,0-.73-.5A.79.79,0,0,0,186.3,72.66Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    className: "cls-22",
    cx: 264.61,
    cy: 94.06,
    rx: 12.7,
    ry: 12.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    className: "cls-21",
    cx: 262.63,
    cy: 81.36,
    rx: 3.36,
    ry: 4.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    className: "cls-23",
    d: "M182.54,97.69c.12.15.22.31.34.47a4.81,4.81,0,0,0,2.62,1.59,12.48,12.48,0,0,0,3.11.29,14.77,14.77,0,0,0,3.25-.27,5.72,5.72,0,0,0,2.86-1.51c.28-.29.55-.64.95-.69a1,1,0,0,1,1,.94v0c0,1-1,1.53-1.75,1.94a12.3,12.3,0,0,1-2.74,1.11,13.73,13.73,0,0,1-5.88.31,8.91,8.91,0,0,1-2.94-1,4.9,4.9,0,0,1-2.11-2.21,1.68,1.68,0,0,1-.18-.83.8.8,0,0,1,.47-.67.9.9,0,0,1,.83.23Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    className: "cls-21",
    d: "M178.23,67.13c-2.37,0-4.14-1.94-6.4-2.34A10,10,0,0,0,165,66c-1,.6-2.3,1.41-3.28.73a1.74,1.74,0,0,1-.58-1.85,3.6,3.6,0,0,1,1.12-1.69,10.29,10.29,0,0,1,8.15-2.4,21.2,21.2,0,0,1,8.18,3c.69.4,1.45.94,1.51,1.74a1.75,1.75,0,0,1-1.79,1.64Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    className: "cls-21",
    d: "M198.18,66.81c2.36.13,4.22-1.76,6.49-2.08a10,10,0,0,1,6.8,1.45c1,.65,2.24,1.5,3.24.86a1.75,1.75,0,0,0,.66-1.82,3.71,3.71,0,0,0-1.06-1.74,10.32,10.32,0,0,0-8.05-2.72A21.31,21.31,0,0,0,198,63.42c-.71.37-1.49.88-1.58,1.68s.82,1.64,1.72,1.71Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    className: "cls-13",
    d: "M183.27,204.54l-.21,3.9c-1.36,9.1-7.29,9.95-19.45,11.92l-1-.33.25-3.42,5.64-.92,1-.19,2.07-.41.87-.2a26.63,26.63,0,0,0,4.08-1.24h0a2.52,2.52,0,0,0,.33-.14,11.55,11.55,0,0,0,2.48-1.44l.26-.2a7.14,7.14,0,0,0,.75-.7,2.61,2.61,0,0,0,.23-.24l.22-.26A8.84,8.84,0,0,0,182,208.9a3.54,3.54,0,0,0,.16-.34,3.49,3.49,0,0,0,.15-.34,3.84,3.84,0,0,0,.14-.36,13.31,13.31,0,0,0,.49-1.55c0-.13.06-.27.1-.42C183.11,205.46,183.2,205,183.27,204.54Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    className: "cls-24",
    d: "M175.87,192.6l-3.36.25-1.38.1-4.54.35-7.35-18.07,3.37-2.67-5.8-6.15S151.68,145,154.2,140s17.73-11.9,17.73-11.9a28.74,28.74,0,0,0-5.34,19.47c.62,7.55,4.24,23.85,6.76,34.63.35,1.48.68,2.86,1,4.1C175.25,190.12,175.87,192.6,175.87,192.6Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    className: "cls-24",
    d: "M202.48,128.07s7.23,11.19,4.8,23-12,40.68-12,40.68,8.05-.78,10.25-.77l7.82-17.29L211.13,170l5.24-3.49s4.61-21,1.89-27.83A58,58,0,0,0,202.48,128.07Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    className: "cls-7",
    d: "M198.67,299.18H176.22q.22-7.28.44-14.87h21Q198.09,291.77,198.67,299.18Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    className: "cls-25",
    d: "M197.61,284.41h-21a.41.41,0,0,0,0-.11c0-.2,0-.4,0-.6.11-3.16.2-6.39.28-9.66h19.93c.21,3.41.45,6.84.72,10.26Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    className: "cls-26",
    x: 235.96,
    y: 272.74,
    width: 16.4,
    height: 11.97,
    rx: 5.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    className: "cls-27",
    d: "M197.39,281.39a29.94,29.94,0,0,1-5.06-.8c-3-.77-6.52-2-9.11-1.07a20.13,20.13,0,0,1-6.44,1.06q.1-3.22.18-6.53v-.24l10.65-2.95L197,275C197.08,277.16,197.23,279.27,197.39,281.39Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    className: "cls-9",
    d: "M177,270.76s-.27,4.53-.18,5.34,4.46.27,6.76-.54,5.46.26,8.08.95a28.73,28.73,0,0,0,5.46.77l-.33-5.24-9.32-4.17Z",
    transform: "translate(57.12 -0.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    className: "cls-16",
    d: "M204.39,199a10.44,10.44,0,0,1-4.94,3.45,21.35,21.35,0,0,0-4.15,1.68l-1,.48c-3,1.47-5.81,2.53-11.07-.1l.21-4.12c2.89.61,7,1.27,10,.84C196.57,200.81,201.26,199.76,204.39,199Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    className: "cls-28",
    d: "M226.31,75c-.29-3.49-3-2.55-3-2.55a1.57,1.57,0,0,1-.53,0H160.55c-3.15,0-6.27-.35-9.4-.24-1,0-3.44-.18-4,1a2,2,0,0,0-.12.85v2.41a2.7,2.7,0,0,0,.07.69,3,3,0,0,0,2.47,1.68l3.34.08.6,7.79c.44,6,6.82,6.77,6.82,6.77H176.7c6.83-.65,6.83-15,6.83-15,4-4.31,7.44,0,7.44,0,.88,14.31,9.5,15,9.5,15h15.15c7.12-1.6,6.24-14.33,6.24-14.33h3C227.2,78.82,226.31,75,226.31,75Zm-75.6,2.47a1.67,1.67,0,1,1,1.55-1.78.45.45,0,0,1,0,.11,1.62,1.62,0,0,1-1.56,1.66Zm30,2.16a46.84,46.84,0,0,1-.83,5.13,10.11,10.11,0,0,1-2,4.37,7.9,7.9,0,0,1-3.33,2.15,26.08,26.08,0,0,1-8.13,1.24c-2.71.11-5.58.2-8-1.15a5,5,0,0,1-1.95-1.82,8.4,8.4,0,0,1-.84-3.58c-.17-2-.33-4.07-.5-6.1a6.88,6.88,0,0,1,.24-3.12,3.2,3.2,0,0,1,2.77-1.86,4.91,4.91,0,0,1,.86,0c2,0,3.95,0,5.93,0h12.06a5.09,5.09,0,0,1,1.86.22,3,3,0,0,1,1.79,2,6.36,6.36,0,0,1,0,2.57Zm39.13.2c-.17,2-.34,4-.49,6.06a8.1,8.1,0,0,1-.85,3.55,5,5,0,0,1-2,1.8c-2.42,1.34-5.27,1.27-8,1.15a26.67,26.67,0,0,1-8.13-1.23A8.11,8.11,0,0,1,197.12,89a10.24,10.24,0,0,1-2-4.34,51.43,51.43,0,0,1-.84-5.09,6.31,6.31,0,0,1,0-2.56,3,3,0,0,1,1.78-2,5.09,5.09,0,0,1,1.86-.22h12.06c2,0,4,0,5.94,0a6.2,6.2,0,0,1,.86,0,3.14,3.14,0,0,1,2.76,1.85,6.35,6.35,0,0,1,.24,3.09Zm3.72-2.36a1.67,1.67,0,1,1,1.57-1.77v.1a1.6,1.6,0,0,1-1.56,1.66h0Z",
    transform: "translate(57.12 -0.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    className: "cls-29",
    d: "M180.73,79.62a49.84,49.84,0,0,1-.84,5.13,10,10,0,0,1-1.95,4.36,7.86,7.86,0,0,1-3.33,2.16,26.38,26.38,0,0,1-8.13,1.24c-2.71.1-5.58.19-8-1.16a5.09,5.09,0,0,1-2-1.82A8.47,8.47,0,0,1,155.7,86q-.24-3.06-.5-6.11a6.83,6.83,0,0,1,.25-3.11,3.16,3.16,0,0,1,2.76-1.87,8.27,8.27,0,0,1,.86-.05h18a5.31,5.31,0,0,1,1.86.22,3,3,0,0,1,1.78,2A6.28,6.28,0,0,1,180.73,79.62Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    className: "cls-29",
    d: "M219.85,79.82c-.16,2-.33,4-.48,6.06a8.42,8.42,0,0,1-.85,3.55,5.14,5.14,0,0,1-2,1.8c-2.42,1.34-5.27,1.27-8,1.14a26.36,26.36,0,0,1-8.13-1.22A8.11,8.11,0,0,1,197.12,89a10.13,10.13,0,0,1-2-4.34c-.38-1.68-.61-3.38-.83-5.09a6.49,6.49,0,0,1,0-2.56,3,3,0,0,1,1.79-2,5.55,5.55,0,0,1,1.86-.22h18a6.33,6.33,0,0,1,.86.06,3.16,3.16,0,0,1,2.76,1.85A6.35,6.35,0,0,1,219.85,79.82Z",
    transform: "translate(57.12 -0.5)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    className: "cls-21",
    cx: 229.28,
    cy: 81.36,
    rx: 3.36,
    ry: 4.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    className: "cls-21",
    cx: 262.63,
    cy: 81.36,
    rx: 3.36,
    ry: 4.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    className: "cls-10",
    d: "M251.06,381.63l-8-71.78-6-54-4-35.53L232,210.89a19.11,19.11,0,0,0,.83-2,.06.06,0,0,0,0,0c1.68-4.76,4-14,4.43-16,0-.13.06-.25.09-.38.63,4.88,1.29,11,2,17.93,1.23,12.76,2.5,28.48,3.74,45.17,1.32,17.91,2.6,36.95,3.73,54.66C249.22,348.2,251,380.08,251.06,381.63Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    className: "cls-13",
    d: "M239.33,210.39c-2.75,5-6.13,11.14-6.13,11.14-.19-.07,0-1.09-.14-1.19-2.51-1.77-1.05-9.45-1.05-9.45.28-.66.56-1.34.82-2.06a.05.05,0,0,0,0,0,123.67,123.67,0,0,0,4.43-16l.09-.37C238,197.34,238.66,203.43,239.33,210.39Z",
    transform: "translate(57.12 -0.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    className: "cls-30",
    d: "M151.86,255.23s-.63,31-5.2,35.35c-3.48,3.3-8.49,8.13-17.19,8.6,0-10.41.21-20.13.58-27,.32-5.74.79-11.48,1.32-16.92A162.89,162.89,0,0,0,151.86,255.23Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    className: "cls-30",
    d: "M246.8,299.46a24.74,24.74,0,0,1-3.75-.3c-7.24-1.14-11.62-5.36-14.76-8.35-4.57-4.35-5.2-35.35-5.2-35.35a132.31,132.31,0,0,0,13.94.28c2.85-.07,5.08-.19,6-.25C244.39,269.9,245.66,285.21,246.8,299.46Z",
    transform: "translate(57.12 -0.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    className: "cls-31",
    d: "M163,193.6l-1.7.15c-.36-.73-.68-1.48-1-2.23-3-7.81-3.2-16.56-3.12-24.92,0,0,.24.13.25.13l1.2.12A92.66,92.66,0,0,0,160,183.73,34.43,34.43,0,0,0,163,193.6Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    className: "cls-31",
    d: "M176.19,166.13s-.45,8.88-.63,10.68a75.09,75.09,0,0,1-1.23,9.46,45.84,45.84,0,0,1-1.82,6.58l-1.39.1a61.06,61.06,0,0,0,2.23-10.78c1.07-8,1.34-16.11,1.34-16.11Z",
    transform: "translate(57.12 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    className: "cls-32",
    d: "M176.73,157.44a10.47,10.47,0,0,0-4.59-7.14,9.84,9.84,0,0,0-3.7-1.17c-1.5-16.82,9.41-25.68,9.41-25.68l0-2.54C164.51,128.57,166,149,166,149a8.86,8.86,0,0,0-4,1.05,10,10,0,0,0-3.75,4.49,19.82,19.82,0,0,0-1.4,12.89v0a1.4,1.4,0,0,0,1.77-.74,4.42,4.42,0,0,0,.31-2.1,30.45,30.45,0,0,1,.82-7.05,8.71,8.71,0,0,1,1.55-3.57c4.23-5.11,11.74-2.06,13.13,3.65a22,22,0,0,1-.07,8.37l2.36.11A25.79,25.79,0,0,0,176.73,157.44Z",
    transform: "translate(57.12 -0.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    className: "cls-32",
    d: "M196.79,123.75s9.77,1.76,11,23.4S204.39,191,204.39,191l2.48,0s3.17-18.82,3.62-29.31.09-21.27-3.71-30-10-10.28-10-10.28Z",
    transform: "translate(57.12 -0.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreOpSurgeon);
export default __webpack_public_path__ + "static/media/Pre_Op_Surgeon.4d3b24d9.svg";
export { ForwardRef as ReactComponent };